// Texts of the 3D card's hint and legend (translated by useView3DLabels in labels.ts; the ones depending on the
// connection type follow the HTML's updateThreeLabels) and the legend swatch of element 1.
import { isPanelMat } from "../../../http/screwConnector/formulas/ctx";
import type { CalculationConnectionType } from "../../../http/screwConnector/types/common";
import { PANEL_WOOD_BORDER, PANEL_WOOD_CSS } from "./view3dScene";

export type ScrewConnector3DLabels = {
  hintControls: string;
  hintSubject: string; // "<the elements> are" ... the geometric context
  hintTail: string;
  element2: string;
  element1: string;
  // rows of the Elements menu: element 3 is listed with the element it copies
  menuElement1: string;
  menuElement2: string;
  screwOk: string;
  screwBad: string;
  dims: string;
  fn: string;
  fv: string;
  fa: string;
};

// Legend swatch of element 1: the panel colour for wood-based panels, the element 1 timber colour otherwise.
export function element1Swatch(ct: CalculationConnectionType): { background: string; borderColor: string } {
  return isPanelMat(ct)
    ? { background: PANEL_WOOD_CSS, borderColor: PANEL_WOOD_BORDER }
    : { background: "var(--gravel-200)", borderColor: "var(--gravel-600)" };
}
